import React from "react";
import { makeStyles, Theme } from "@material-ui/core";

import { Field } from "react-final-form";
import { Select } from "final-form-material-ui";
import MenuItem from "@material-ui/core/MenuItem";

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    display: "grid",
    gridTemplateColumns: "150px 300px",
    gap: `${theme.spacing(2)}px`,
    textAlign: "right",
    alignItems: "center",
    "& label": {
      fontSize: "16px",
    },
    "& div": {
      marginTop: "3px",
    },
  },
  select: {
    textAlign: "left",
    width: "300px",
    height: "50px",
    padding: 0,
    marginTop: "-14px",
  },
}));

type Data = {
  display: string;
  value: number | string;
};

type Props = {
  data: Data[];
  title: string;
  field: string;
  disabled?: boolean;
  addEmptyValue?: string;
  onParse?: (value: any) => void;
};

export const SelectField: React.FC<Props> = ({ title, field, data, addEmptyValue, onParse, disabled = false }) => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <label>{title}:</label>
      <div>
        <Field
          name={field}
          parse={(value) => {
            if (onParse) {
              onParse(value);
            }
            return value;
          }}
          disabled={disabled}
          render={(props) => <Select {...props} label="" formControlProps={{ fullWidth: true, className: classes.select }} />}
        >
          {addEmptyValue && (
            <MenuItem key={"emptyvalueMenuItem"} value={-1}>
              {addEmptyValue}
            </MenuItem>
          )}
          {(data || []).map((item, index: number) => (
            <MenuItem key={`${item.value}${index}`} value={item.value}>
              {item.display}
            </MenuItem>
          ))}
        </Field>
      </div>
    </div>
  );
};
